import React, { useLayoutEffect } from 'react';
import classNames from 'classnames';
import { useMeasure } from 'react-use';

export const SubHeaderLeft = ({ children, className }) => {
  return <div className={classNames('subheader-left', 'col-sm', className)}>{children}</div>;
};

export const SubHeaderRight = ({ children, className }) => {
  return (
    <div className={classNames('subheader-right', 'col-sm-auto', className)}>
      {children}
    </div>
  );
};

export const SubheaderSeparator = ({ className }) => {
  return <div className={classNames('subheader-separator', className)} />;
};

const SubHeader = ({ children, className }) => {
  const [ref, { height }] = useMeasure();

  const root = document.documentElement;
  root.style.setProperty('--subheader-height', `${height}px`);

  useLayoutEffect(() => {
    document.body.classList.add('subheader-enabled');
    return () => {
      document.body.classList.remove('subheader-enabled');
    };
  }, []);

  return (
    <div ref={ref} className={classNames('subheader', 'row', className)}>
      {children}
    </div>
  );
};

export default SubHeader;
